<template>
  <div class="flex flex-wrap -mx-4">
    <div class="w-12/12 py-12">
      <div v-html="campaign.html" />
    </div>
    <CalendarWrapper
      v-slot="{ tableBusy, loading, next, fetch, prevNav, pageHandle, resetFilters, cachedList }"
      is-last-minute
      is-infinite
    >
      <CalendarViewList
        class="px-4"
        view-mode="list"
        :loading="loading"
        :show-next="!!next"
        :show-previous="!!prevNav"
        :table-busy="tableBusy"
        :trips="cachedList"
        :show-last-minute="false"
        :full-width="true"
        :show-view-mode="false"
        :has-predefined-airport="hasPredefinedAirport"
        @fetch="fetch('list')"
        @next="pageHandle(next)"
        @previous="pageHandle(prevNav)"
        @reset-filters="resetFilters"
      >
        <template #aboveCal>
          <div
            id="campaignActionBtnScrollToElement"
            class="w-full mx-auto px-4 flex flex-row bg-blue mt-4 pt-4 pb-2 flex-wrap justify-center"
          >
            <div class="h4 flex text-white pr-2">
              {{ campaign.topic }}
            </div>
            <div class="h4 md:grow pr-4 flex text-orange">
              {{ campaign.sub_title }}
            </div>
            <div class="h4 text-white uppercase">
              {{ campaign.call_to_action_text }}
            </div>
          </div>
        </template>
      </CalendarViewList>
    </CalendarWrapper>
  </div>
</template>

<script>
import { mapActions } from 'pinia'

export default defineNuxtComponent({
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasPredefinedAirport () {
      return !!this.campaign.origin_airports?.length
    },
  },

  beforeDestroy () {
    this.resetCalendarFilters(false)
  },

  methods: {
    ...mapActions(useCalendarStore, {
      resetCalendarFilters: 'resetFilters',
    }),
  },
})
</script>
